// import React, { useState } from 'react'
// import { Container, Row, Col, Button, Card, CardBody, Form } from 'react-bootstrap'
// import { Link, useNavigate } from 'react-router-dom'
// import MyAccoutSideBar from './MyAccoutSideBar'
// import { fetch } from '../../../../utils'
// import LoginSideNav from './LoginSideNav'
// const Register = () => {
//     const navigate = useNavigate();
//     const [registrationMessage, setRegistrationMessage] = useState('');
//     const [errorMessage, setErrorMessage] = useState("");
//     const [passwordsMatch, setPasswordsMatch] = useState(true);
//     const [formData, setFormData] = useState({
//         customer_password: '',
//         confirmPassword: '',
//         customer_mobile: '',
//         customer_address: '',
//         customer_email: '',
//         customer_fname: '',
//         customer_lname: '',
//     });
//     const registerUser = async (e) => {
//         e.preventDefault();
//         if (formData.customer_password !== formData.confirmPassword) {
//             setPasswordsMatch(false);
//             return;
//         }

//         try {
//             const body = {
//                 customer_password: formData.customer_password,
//                 confirmPassword: formData.confirmPassword,
//                 customer_mobile: formData.customer_mobile,
//                 customer_address: "",
//                 customer_email: formData.customer_email,
//                 customer_fname: formData.customer_fname,
//                 customer_lname: formData.customer_lname,
//             };
//             const response = await fetch('/customer/register', 'POST', body, null);
//             if (response.data.success) {
//                 const token = response.data.token; // Assuming the response contains a unique token
//                 setRegistrationMessage(response.message); // Display the response message
//                 navigate("/account/login");

//             } else {
//                 setRegistrationMessage(response.message);
//             }
//         } catch (error) {
//             if (error.response && error.response.data && error.response.data.message) {
//                 setErrorMessage(<font color="red"><b>{error.response.data.message}</b></font>);
//             } else if (error && error.message) {
//                 setErrorMessage(<font color="red"><b>{error.message}</b></font>);
//             } else {
//                 setErrorMessage(<font color="red"><b>Something went wrong.</b></font>);
//             }
//         }
//     };
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };
//     return (
//         <>
//             <hr />
//             <Container>
//                 <font> Home › My Accoun › Register</font>
//                 <Row className='pt-4'>
//                     <Col sm={9} >
//                         <Card className='mb-3' style={{ border: 'none' }}>
//                             <CardBody>
//                                 <h5 className='border-bottom pb-2 text-uppercase'>Register Account</h5>
//                                 <p>If you already have an account with us, please login at the login page.</p>

//                                 <h5 >Your Personal Details</h5> <hr />
//                                 <Form className='pt-2' onSubmit={registerUser}>
//                                     <Form.Group as={Row} className="mb-3">
//                                         <Form.Label column sm="3" className='text-end-lg text-start-sm'>
//                                             First Name <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Col sm="9">
//                                             <div className="input-group">
//                                                 <div className="input-group-text" style={{ background: "#a3895b" }}>
//                                                     <i className="fa fa-user-o text-white" aria-hidden="true"></i>
//                                                 </div>
//                                                 <Form.Control
//                                                     type="text"
//                                                     name="customer_fname"
//                                                     value={formData.customer_fname}
//                                                     onChange={handleChange}
//                                                     placeholder="First Name"
//                                                 />
//                                             </div>
//                                         </Col>
//                                     </Form.Group>
//                                     <Form.Group as={Row} className="mb-3">
//                                         <Form.Label column sm="3">
//                                             Last Name <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Col sm="9">
//                                             <div className="input-group">
//                                                 <div className="input-group-text" style={{ background: "#a3895b" }}>
//                                                     <i className="fa fa-user-o text-white" aria-hidden="true"></i>
//                                                 </div>
//                                                 <Form.Control
//                                                     type="text"
//                                                     name="customer_lname"
//                                                     value={formData.customer_lname}
//                                                     onChange={handleChange}
//                                                     placeholder="Last Name"
//                                                 />
//                                             </div>
//                                         </Col>
//                                     </Form.Group>

//                                     <Form.Group as={Row} className="mb-3">
//                                         <Form.Label column sm="3">
//                                             Email <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Col sm="9">
//                                             <div className="input-group">
//                                                 <div className="input-group-text" style={{ background: "#a3895b" }}>
//                                                     <i className="fa fa-envelope-o text-white" aria-hidden="true"></i>
//                                                 </div>
//                                                 <Form.Control
//                                                     type="text"
//                                                     name="customer_email"
//                                                     value={formData.customer_email}
//                                                     onChange={handleChange}
//                                                     placeholder="Email"
//                                                 />
//                                             </div>
//                                         </Col>
//                                     </Form.Group>

//                                     <Form.Group as={Row} className="mb-3">
//                                         <Form.Label column sm="3">
//                                             Phone <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Col sm="9">
//                                             <div className="input-group">
//                                                 <div className="input-group-text" style={{ background: "#a3895b" }}>
//                                                     <i className="fa fa-phone text-white" aria-hidden="true"></i>
//                                                 </div>
//                                                 <Form.Control
//                                                     type="number"
//                                                     name="customer_mobile"
//                                                     value={formData.customer_mobile}
//                                                     onChange={handleChange}
//                                                     placeholder="Mobile Number"
//                                                 />
//                                             </div>
//                                         </Col>
//                                     </Form.Group>

//                                     <h5 className='pt-4'>Your Password</h5> <hr />
//                                     <Form.Group as={Row} className="mb-3">
//                                         <Form.Label column sm="3">
//                                             Password <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Col sm="9">
//                                             <div className="input-group">
//                                                 <div className="input-group-text" style={{ background: "#a3895b" }}>
//                                                     <i className="fa fa-lock text-white" aria-hidden="true"></i>
//                                                 </div>
//                                                 <Form.Control
//                                                     type="password"
//                                                     name="customer_password"
//                                                     value={formData.customer_password}
//                                                     onChange={handleChange}
//                                                     placeholder="Password"
//                                                 />
//                                             </div>
//                                         </Col>
//                                     </Form.Group>

//                                     <Form.Group as={Row} className="mb-3">
//                                         <Form.Label column sm="3">
//                                             Password Confirm <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Col sm="9">
//                                             <div className="input-group">
//                                                 <div className="input-group-text" style={{ background: "#a3895b" }}>
//                                                     <i className="fa fa-lock text-white" aria-hidden="true"></i>
//                                                 </div>
//                                                 <Form.Control
//                                                     type="password"
//                                                     name="confirmPassword"
//                                                     value={formData.confirmPassword}
//                                                     onChange={handleChange}
//                                                     placeholder="Confirm Password"
//                                                 />
//                                             </div>
//                                             {!passwordsMatch && <p className="text-danger">Passwords do not match</p>}
//                                         </Col>
//                                     </Form.Group>

//                                     <Form.Group as={Row} className="mb-3">
//                                         <Form.Label column sm="3">
//                                         </Form.Label>
//                                         <Col sm="9">
//                                             <p className='pt-1 m-0 p-0'>Already have an account ? <Link to='/account/login'>Login</Link>  </p>
//                                             <div className='text-end'>
//                                                 <Button
//                                                     type="submit"
//                                                     variant="primary"
//                                                     className="bg-main-color px-5"
//                                                 >
//                                                     Register
//                                                 </Button>
//                                             </div>
//                                         </Col>
//                                     </Form.Group>

//                                 </Form>
//                             </CardBody>
//                         </Card>
//                     </Col>
//                     <Col sm={3}>
//                         <LoginSideNav />
//                     </Col>
//                 </Row>
//             </Container>
//         </>
//     )
// }

// export default Register

import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Form,
  Spinner,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { fetch } from "../../../../utils";
import LoginSideNav from "./LoginSideNav";

const Register = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [validationErrors, setValidationErrors] = useState({
    customer_fname: "",
    customer_lname: "",
    customer_email: "",
    customer_mobile: "",
    customer_password: "",
  });
  const [formData, setFormData] = useState({
    customer_password: "",
    customer_mobile: "",
    customer_address: "",
    customer_email: "",
    customer_fname: "",
    customer_lname: "",
  });
  const registerUser = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const body = {
        customer_password: formData.customer_password,
        customer_mobile: formData.customer_mobile,
        customer_address: '',
        customer_email: formData.customer_email,
        customer_fname: formData.customer_fname,
        customer_lname: formData.customer_lname,
      };
      const response = await fetch("/customer/register", "POST", body, null);
      if (response.data.success) {
        setLoading(true);
        navigate("/account/login");
        // setTimeout(() => {
        //   setLoading(true);
        //   navigate("/account/login");
        // }, 4000); // Adjust the delay time as needed
      } else {
        // setRegistrationMessage(response.message);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setErrorMessage(<font color="red">{error.response.data.message}</font>);
      } else if (error && error.message) {
        setErrorMessage(<font color="red">{error.message}</font>);
      } else {
        setErrorMessage(<font color="red">Something went wrong.</font>);
      }
    } finally {
      setLoading(false); // Set loading to false after registration completes
    }
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };


  const handleChange = (e) => {
    const { name, value } = e.target;
    let errors = { ...validationErrors };
    switch (name) {
      case "customer_fname":
        errors.customer_fname =
          value.length < 1 ? "First name is required" : "";
        break;
      case "customer_lname":
        errors.customer_lname =
          value.length < 1 ? "Last name is required" : "";
        break;
      case "customer_email":
        errors.customer_email = !/\S+@\S+\.\S+/.test(value)
          ? "Email address is invalid"
          : "";
        break;
      case "customer_mobile":
        errors.customer_mobile =
          value.length !== 10 ? "Mobile number must be 10 digits" : "";
        break;
      case "customer_password":
        errors.customer_password =
          value.length < 6 ? "Password must be at least 6 characters" : "";
        break;
      default:
        break;
    }

    setValidationErrors(errors);
    setFormData({ ...formData, [name]: value });
  };


  return (
    <>
      <hr />
      <Container>
        <font> Home › My Account › Register</font>
        <Row className="pt-4">
          <Col sm={9}>
            <Card className="mb-3" style={{ border: "none" }}>
              <CardBody>
                <h5 className="border-bottom pb-2 text-uppercase">
                  Register Account
                </h5>
                <p>
                  If you already have an account with us, please login at the
                  login page.
                </p>
                <h5>Your Personal Details</h5> <hr />
                <Form className="pt-2" onSubmit={registerUser}>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label
                      column
                      sm="3"
                      className="text-end-lg text-start-sm"
                    >
                      First Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm="9">
                      <div className="input-group">
                        <div
                          className="input-group-text"
                          style={{ background: "#a3895b" }}
                        >
                          <i
                            className="fa fa-user-o text-white"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <Form.Control
                          type="text"
                          name="customer_fname"
                          value={formData.customer_fname}
                          onChange={handleChange}
                          placeholder="First Name"
                        />
                      </div>
                      {validationErrors.customer_fname && (
                        <span className="text-danger">{validationErrors.customer_fname}</span>
                      )}
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="3">
                      Last Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm="9">
                      <div className="input-group">
                        <div
                          className="input-group-text"
                          style={{ background: "#a3895b" }}
                        >
                          <i
                            className="fa fa-user-o text-white"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <Form.Control
                          type="text"
                          name="customer_lname"
                          value={formData.customer_lname}
                          onChange={handleChange}
                          placeholder="Last Name"
                        />
                      </div>
                      {validationErrors.customer_lname && (
                        <span className="text-danger">{validationErrors.customer_lname}</span>
                      )}

                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="3">
                      Email <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm="9">
                      <div className="input-group">
                        <div
                          className="input-group-text"
                          style={{ background: "#a3895b" }}
                        >
                          <i
                            className="fa fa-envelope-o text-white"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <Form.Control
                          type="text"
                          name="customer_email"
                          value={formData.customer_email}
                          onChange={handleChange}
                          placeholder="Email"
                        />
                      </div>

                      {validationErrors.customer_email && (
                        <span className="text-danger">{validationErrors.customer_email}</span>
                      )}
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="3">
                      Phone <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm="9">
                      <div className="input-group">
                        <div
                          className="input-group-text"
                          style={{ background: "#a3895b" }}
                        >
                          <i
                            className="fa fa-phone text-white"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <Form.Control
                          type="number"
                          name="customer_mobile"
                          value={formData.customer_mobile}
                          onChange={handleChange}
                          placeholder="Mobile Number"
                          maxLength={10} // Set the maximum length to 10
                        />
                      </div>

                      {validationErrors.customer_mobile && (
                        <span className="text-danger">{validationErrors.customer_mobile}</span>
                      )}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="3">
                      Password <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm="9">
                      <div className="input-group">
                        <div
                          className="input-group-text"
                          style={{ background: "#a3895b" }}
                        >
                          <i
                            className="fa fa-lock text-white"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <Form.Control
                          type="password"
                          name="customer_password"
                          value={formData.customer_password}
                          onChange={handleChange}
                          placeholder="Password"
                        />
                      </div>
                      {validationErrors.customer_password && (
                        <span className="text-danger">{validationErrors.customer_password}</span>
                      )}
                      <Form.Group as={Row} className="mb-3">
                        <Col sm="12">
                          <p className="pt-0 m-0 p-0">
                            Already have an account ?{" "}
                            <Link to="/account/login">Login</Link>{" "}
                          </p>
                          <p className="text-end">{errorMessage}</p>
                          <div className="text-end">
                            {/* <Button
                              type="submit"
                              variant="primary"
                              className="bg-main-color px-5"
                              disabled={loading}
                            >
                              {loading ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                "Register"
                              )}
                            </Button> */}
                            <Button
                              type="submit"
                              variant="primary"
                              className="bg-main-color px-5"
                              disabled={loading}  // Disable if loading or email is empty
                            >
                              {loading ? 'Loading...' : 'Register'}
                              {/* {loading ? (
                                <>
                                  <Spinner animation="border" size="sm" />
                                  {" Wait..."}
                                </>
                              ) : (
                                "Register"
                              )} */}
                            </Button>
                          </div>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Form.Group>
                </Form>
              </CardBody>
            </Card>
          </Col>
          <Col sm={3}>
            <LoginSideNav />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Register;
